import { tokens } from '@welbe/web-design-system';
import styled, { css } from 'styled-components';
import { listKindEnum } from './RiskFactors';

export const Container = styled.div<{ isLoading: boolean }>`
	display: grid;
	grid-template-columns: 1fr 1fr 1fr 1fr;
	gap: 10px;

	@media (max-width: 1600px) {
		grid-template-columns: 1fr 1fr 1fr;

		${({ isLoading }) =>
			isLoading &&
			`
		div:last-child {
			display: none;
		}
		`}
	}
`;

export const GrayBox = styled.div<{ listKind: listKindEnum }>`
	display: grid;
	background-color: ${tokens.color_gray_light};
	padding: 15px;

	border-radius: 6px;

	grid-template-rows: ${({ listKind }) =>
		listKind === listKindEnum.biggerList ? '42px 40px 1fr' : '1fr'};

	& svg {
		cursor: pointer;
		align-self: flex-end;
	}
`;

export const Header = styled.div`
	display: grid;
	height: 50px;
	grid-template-columns: 50px 1fr 30px;

	& img {
		width: 40px;
		height: 40px;
	}

	& svg {
		align-self: center;
		cursor: pointer;
	}
`;

export const Separator = styled.hr`
	height: 1px;
	border: 1px solid ${tokens.color_ink_lightest};
	margin: 20px 0;
`;

export const Badge = styled.div<{ color: string }>`
	background-color: ${(props) => props.color};
	width: 10px;
	height: 10px;
	border-radius: 50%;
`;

export const FactorContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: start;
`;

export const DescriptionContainer = styled.div`
	display: flex;
	align-items: start;
	justify-content: space-between;
	width: 100%;

	padding-bottom: 15px;

	p {
		display: block;
		display: -webkit-box;
		max-width: 350px;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		overflow: hidden;
		text-overflow: ellipsis;
	}
`;

export const LabelContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 10px;
	align-items: center;
	gap: 10px;
`;

export const HeaderContainer = styled.div`
	display: flex;
	justify-content: space-between;
	width: 100%;
`;

export const IconContainer = styled.div<{ listKind: listKindEnum }>`
	display: flex;
	gap: 20px;

	svg {
		cursor: pointer;
		:nth-child(1) {
			path {
				fill: ${({ listKind }) =>
					listKind === listKindEnum.list
						? tokens.color_primary
						: tokens.color_gray_medium};
			}
		}
		:nth-child(2) {
			path {
				fill: ${({ listKind }) =>
					listKind === listKindEnum.biggerList
						? tokens.color_primary
						: tokens.color_gray_medium};
			}
		}
	}
`;

export const FileContainer = styled.div<{ hasFile: boolean }>`
	display: flex;
	align-items: center;
	gap: 15px;

	svg {
		cursor: pointer;
		align-self: center;
	}

	${({ hasFile }) =>
		!hasFile &&
		css`
			svg {
				cursor: not-allowed;
				path {
					fill: ${tokens.color_gray_medium};
				}
			}
		`}
`;
